function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M16 8a8.001 8.001 0 01-5.467 7.587c-.406.079-.55-.17-.55-.384 0-.262.01-1.125.01-2.194a1.909 1.909 0 00-.543-1.482c1.782-.198 3.653-.874 3.653-3.946a3.086 3.086 0 00-.823-2.147 2.872 2.872 0 00-.08-2.116s-.67-.215-2.197.82a7.584 7.584 0 00-4.006 0c-1.528-1.035-2.2-.82-2.2-.82a2.876 2.876 0 00-.078 2.116 3.091 3.091 0 00-.824 2.147c0 3.065 1.868 3.75 3.644 3.953a1.709 1.709 0 00-.508 1.069 1.704 1.704 0 01-2.328-.665 1.68 1.68 0 00-1.225-.824s-.781-.01-.055.486c.426.272.741.687.888 1.17 0 0 .47 1.556 2.695 1.072.004.668.01 1.171.01 1.36 0 .213-.145.46-.545.386A8 8 0 1116 8z",
  id: "github_svg__a"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "github_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#github_svg__a"
})), React.createElement("use", {
  fill: "currentColor",
  xlinkHref: "#github_svg__a"
}), React.createElement("g", {
  mask: "url(#github_svg__b)",
  fill: "currentColor"
}, React.createElement("path", {
  d: "M0 0h20v20H0z"
})));

var Github = function Github(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _ref, _ref2);
};

export default Github;